import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';

export default function Impressum() {
    return (
        <div className="legal-page">
            <div className="legal-content">
                <Link to="/" className="legal-back">‹ Zurück</Link>
                <h1>Impressum</h1>

                <h2>Angaben gemäß § 5 TMG</h2>
                <p>
                    TechCrafters GmbH<br />
                    Schulstrasse 12<br />
                    78652 Deisslingen
                </p>

                <h2>Vertreten durch</h2>
                <p>Philipp Schinacher</p>

                <h2>Kontakt</h2>
                <p>
                    Telefon: +49 7420 405 10 93<br />
                    E-Mail: info@techcrafters.de
                </p>

                <h2>Registereintrag</h2>
                <p>
                    Eintragung im Handelsregister.<br />
                    Registergericht: Amtsgericht Stuttgart<br />
                    Registernummer: 790891
                </p>

                <h2>Umsatzsteuer-ID</h2>
                <p>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                    DE362653553
                </p>

                <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                <p>
                    TechCrafters GmbH<br />
                    Schulstrasse 12<br />
                    78652 Deisslingen
                </p>

                <h2>Haftung für Inhalte</h2>
                <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
                    nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                    Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                    Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
                    rechtswidrige Tätigkeit hinweisen.
                </p>

                <h2>Haftung für Links</h2>
                <p>
                    Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir
                    keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
                    übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
                    Betreiber der Seiten verantwortlich.
                </p>
            </div>
        </div>
    );
}
